'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    window.history.scrollRestoration = 'manual';
    processInclude(require('./product/detail'));
    processInclude(require('./product/accessibility'));
    processInclude(require('./product/wishlist'));
    require('pinch-zoom-element');
    processInclude(require('./product/zoom'));
    processInclude(require('./product/bisn'));
    processInclude(require('./product/afterpayContent'));
    if (window.sitePrefs.enableUnisize) {
        processInclude(require('./unisize/unisize'));
    }
    require('./util/lazyContentLoader').init();
    if (window.sitePrefs.bopisEnabled) {
        processInclude(require('./product/pdpInstoreInventory'));
    }
    if (window.sitePrefs.bvEnabled) {
        processInclude(require('../../../../../org_bazaarvoice_sfra_custom/cartridge/client/default/js/bvDetail'));
    }
    processInclude(require('./checkout/oneyOSM'));
});
